export default __webpack_public_path__ + "static/media/8.0b358d31.png";